import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useApi, useAuth } from "@/lib/auth";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import PageHeader from "@/components/PageHeader";
import { fmtEventDateTime, formatPrice } from "@/lib/format";
import { ChevronRight } from "lucide-react";

export default function OrganisePage() {
  const api = useApi();
  const { user } = useAuth();
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const r = await api("/organiser/events");
        if (r.ok) { const d = await r.json(); setEvents(d.events || []); }
      } finally { setLoading(false); }
    })();
    // eslint-disable-next-line
  }, []);

  return (
    <div>
      <PageHeader title="Organise" subtitle={`Events linked to ${user?.name || "you"}`} testId="organise-page-header" />
      {loading ? (
        <div className="text-sm text-muted-foreground">Loading…</div>
      ) : events.length === 0 ? (
        <Card className="p-8 text-center" data-testid="organise-empty">
          <h3 className="font-semibold">No events assigned</h3>
          <p className="text-sm text-muted-foreground mt-1">
            You'll see events here once an admin sets you as their organiser.
          </p>
        </Card>
      ) : (
        <div className="grid gap-3 md:grid-cols-2">
          {events.map((e) => (
            <Link key={e.event_id} to={`/organise/${e.event_id}`}
                  data-testid={`organise-event-${e.event_id}`} className="block group">
              <Card className="p-4 border-border transition-shadow group-hover:shadow-md">
                <div className="flex items-start justify-between gap-3">
                  <div>
                    <h3 className="font-semibold">{e.name}</h3>
                    <div className="text-sm text-muted-foreground">{fmtEventDateTime(e.starts_at)}</div>
                    {e.location && <div className="text-sm text-muted-foreground">{e.location}</div>}
                    <div className="flex gap-2 flex-wrap mt-2">
                      <Badge variant="outline">{e.stripe_account_label}</Badge>
                      <Badge variant="outline">{formatPrice(e.price_pence, e.currency)}</Badge>
                      <Badge variant="outline">Cap. {e.capacity}</Badge>
                    </div>
                  </div>
                  <ChevronRight className="text-muted-foreground shrink-0 mt-1" size={18} />
                </div>
              </Card>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
